import { BillOfMaterialCreatePage } from '@/features/bill-of-material/pages/BillOfMaterialCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bill-of-material/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bill_of_material.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BillOfMaterialCreatePage,
})
